export default "__VITE_ASSET__Ddz2j4LQ__"